import React from 'react'
import { Toaster, ToastRoot, ToastTitle, ToastDescription, ToastCloseTrigger, ToastIndicator } from '@chakra-ui/react'
import { toaster } from 'stylewhere/shared'

export const ToastContainer: React.FC = () => {
  return (
    <Toaster toaster={toaster}>
      {(toast) => {
        // Se il toast ha un render custom, usalo
        if ((toast as any).render) {
          return (toast as any).render({ id: toast.id, onClose: () => toaster.dismiss(toast.id) })
        }

        return (
          <ToastRoot key={toast.id} style={{ minWidth: '300px', maxWidth: '440px' }}>
            <ToastIndicator />
            {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
            {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
            <ToastCloseTrigger data-testid="close-toast" />
          </ToastRoot>
        )
      }}
    </Toaster>
  )
}
